import { Skeleton } from "@repo/ui/components/ui/skeleton";

/**
 * Loading placeholder for a full-page detail route: a title bar over a
 * centred form column. Every catalog detail route shows the same shape, so
 * they share this rather than each spelling out its own skeleton.
 */
export function DetailSkeleton() {
  return (
    <div className="flex h-full w-full flex-col">
      <div className="flex items-center gap-3 border-b px-4 py-3">
        <Skeleton className="h-8 w-8" />
        <Skeleton className="h-6 w-48" />
      </div>
      <div className="flex-1 p-6">
        <div className="mx-auto max-w-(--form-max-width) space-y-6">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-6 w-64" />
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-6 w-48" />
        </div>
      </div>
    </div>
  );
}
